// ブランド スローガンの横スクロール
(() => {
  const root = document.querySelector(".brand__message__slogan");
  if (!root) return;

  const inner = root.querySelector(".brand__message__slogan__inner");
  if (!inner) return;

  const item = inner.querySelector(".brand__message__slogan__item");
  if (!item) return;

  // ノード複製で幅を十分に確保し、無限ループ可能にする
  const repeatMinWidth = () => {
    const containerWidth = root.clientWidth;
    const itemWidth = item.getBoundingClientRect().width;
    if (itemWidth <= 0) return 2; // フォールバック

    // 2倍幅でアニメーション（50%移動）に合わせる
    const times = Math.ceil((containerWidth * 2) / itemWidth);
    return Math.max(2, times);
  };

  const populate = () => {
    // 初期化（複製をクリア）
    inner.innerHTML = "";
    const text = item.textContent || "";

    const times = repeatMinWidth();
    for (let i = 0; i < times; i++) {
      const span = document.createElement("span");
      span.className = "brand__message__slogan__item";
      span.textContent = text;
      inner.appendChild(span);
    }

    root.classList.add("is-marquee");

    // 速度微調整（テキスト幅に応じて一定のpx/secになるよう調整）
    const totalWidth = inner.getBoundingClientRect().width;
    const pxPerSec = 90; // 1秒あたりの移動px
    const duration = totalWidth / 2 / pxPerSec; // 50%分の距離を移動
    inner.style.animationDuration = `${duration}s`;
  };

  // 初期のitem参照確保のため、一度テンプレートをinnerに入れてからpopulate
  // 初回だけテンプレートを反映
  if (!item) return;
  populate();

  let resizeTimer = null;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(populate, 200);
  });
})();

// ストーリー ラベルのスクロール発火フェード
(() => {
  const labels = document.querySelectorAll(".brand__story__list__item__label");
  if (!labels.length) return;

  const onIntersect = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        if (
          el.dataset.animated === "true" ||
          el.classList.contains("is-done")
        ) {
          observer.unobserve(el);
          return;
        }
        el.classList.add("isActive");
        el.dataset.animated = "true";
        observer.unobserve(el);

        const onEndOnce = () => {
          el.classList.add("is-done");
          el.removeEventListener("transitionend", onEndOnce);
          el.removeEventListener("animationend", onEndOnce);
        };
        el.addEventListener("transitionend", onEndOnce);
        el.addEventListener("animationend", onEndOnce);
      }
    });
  };

  const observer = new IntersectionObserver(onIntersect, {
    root: null,
    rootMargin: "-80% 0px -20%", // 画面下から20%で発火（中央到達時には読みやすい状態）
    threshold: 0,
  });

  labels.forEach((el) => observer.observe(el));
})();
